import { prepareUnlayerPollDesign } from "../utils/unlayer-poll-blocks";

import type { UUID } from "../../../utils/uuid";
import type { EmailMoment } from "../../email-moment/types";
import type { SupabasePollService } from "../../poll/server/supabase-poll-service";

type PollService = Pick<SupabasePollService, "upsertPollWithOptionIds">;

interface PersistUnlayerPollsParams {
  accountId: UUID;
  emailMoment: EmailMoment;
  existingPollIds?: readonly UUID[];
  pollService: PollService;
}

interface PersistUnlayerPollsResult {
  emailMoment: EmailMoment;
  pollIds: UUID[];
}

export async function persistUnlayerPolls({
  accountId,
  emailMoment,
  existingPollIds = [],
  pollService,
}: PersistUnlayerPollsParams): Promise<PersistUnlayerPollsResult> {
  if (!emailMoment.design) return { emailMoment, pollIds: [] };

  const { design, polls } = prepareUnlayerPollDesign(emailMoment.design, existingPollIds);
  for (const poll of polls) {
    await pollService.upsertPollWithOptionIds({
      accountId,
      ...poll,
    });
  }

  return {
    emailMoment: {
      ...emailMoment,
      design,
    },
    pollIds: polls.map(({ pollId }) => pollId),
  };
}
